<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 112 112">
    <path
      d="M59.23,98.44C67.1,88.23,86.63,60.15,86.63,33,86.63,17,72.92,4,56,4S25.37,17,25.37,33c0,27.19,19.53,55.27,27.4,65.48A4.12,4.12,0,0,0,59.23,98.44ZM56,14A20.38,20.38,0,0,1,76.11,34.63a20.12,20.12,0,1,1-40.22,0A20.38,20.38,0,0,1,56,14Zm10,92c0,1.1-4.48,2-10,2s-10-.9-10-2,4.48-2,10-2S66,104.9,66,106Z"
      class="t-visit__geoloc--icon"
    />
  </svg>
</template>
<script>
export default {
  name: 'IconGeoloc'
}
</script>
